/* eslint-disable max-classes-per-file */
import { HTTPError } from '@funtech-int/web-toolkit';

export class SelectionNotFoundError extends HTTPError {
    constructor(public readonly key: string) {
        super(404, `Selection not found, key ${key}`, '');
    }
}

export class EmptySelectionError extends Error {
    constructor(public readonly key: string, public readonly title?: string) {
        super(`Empty selection, key = ${key}`);
    }
}
